import React from 'react';
import cx from 'clsx';
import BottomNavigation from './BottomNavigation';
import SEO from './SEO';
import Header from './Header';
import Footer from './Footer';
import Content from './Content';
import { LayoutContext } from './layout-context';
import * as themeStyles from '../assets/theme.module.scss';
import { showOnlineConsultModal } from '../utils/ciaociao';

const encode = (data) => Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');

const Layout = ({ children, pageContext, ...props }) => {
    const { seo } = pageContext;

    return (
        <LayoutContext.Provider value={{ showOnlineConsultModal }}>
            {seo ? <SEO seo={seo} /> : null}
            <Header handleOnlineConsult={showOnlineConsultModal} />
            <Content>
                {children}
            </Content>
            <Footer />
            <div className={cx(
                themeStyles.navbarToggler,
                themeStyles.dBlock,
                themeStyles.dMdNone,
            )}
            >
                <BottomNavigation />
            </div>
        </LayoutContext.Provider>
    );
};

export default Layout;
